import { createApp } from './vue';

import vimeoPlayer from './vue/apps/vimeo';

const vimeoMountingContainer = document.querySelectorAll('.js-vimeo-container');

if (vimeoMountingContainer) {
    const vimeoPlayers = [];

    vimeoMountingContainer.forEach((el) => {
        const player = createApp(vimeoPlayer).mount(el);
        vimeoPlayers.push(player);
    });
}
